var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[(_vm.loadComplete)?_vm._l((_vm.drillModules.SCORING_ALL),function(drillModule){return _c(drillModule,{tag:"component",attrs:{"isReport":true}})}):_vm._e(),(_vm.error)?_c('error-message'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }